import { useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useRef } from "react";
import { useUploaderInput } from "../../Helpers/useUploaderInput.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import styles from "./styles.module.scss";

export const UploaderEmptyDragArea = ({ handleDrop, handleDrag, dragged }) => {
  const { getTextByKey } = useContent();
  const { getRecipientEmail } = useUploader();
  const { mobileCondition } = useMediaQueries();

  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles, handleAddFolders } = useUploaderInput({
    filesRef,
    folderRef,
  });

  useEffect(() => {
    if (getRecipientEmail()?.length > 1 && mobileCondition) handleAddFiles();
  }, []);

  return (
    <div
      className={styles.wrap}
      onDrop={handleDrop}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
    >
      <div className={`${styles.ui} ${dragged ? styles.dragged : ""}`}>
        <Icon
          name="upload-home"
          iconClass={styles.upload}
          gray
          onClick={handleAddFiles}
        />
        <button
          className={`${styles.selectFiles} ${
            dragged ? styles.transparent : ""
          }`}
          onClick={handleAddFiles}
        >
          {getTextByKey("select-files")}
        </button>
        <button
          className={`${styles.selectFolder} ${
            dragged ? styles.transparent : ""
          }`}
          onClick={handleAddFolders}
        >
          {getTextByKey("select-folder")}
        </button>
        <div className={`${styles.dropHere} ${dragged ? styles.visible : ""}`}>
          {getTextByKey("drag-here-text")}
        </div>
        <div className={styles.hidden}>
          <input type="file" ref={filesRef} multiple />
          <input
            type="file"
            aria-hidden="true"
            //@ts-ignore
            webkitdirectory=""
            directory=""
            multiple
            ref={folderRef}
          ></input>
        </div>
      </div>
    </div>
  );
};
